module.exports = __webpack_public_path__ + "img/24.f522b55c.jpg";